export default __webpack_public_path__ + "static/media/game_1_r.ddaf6386.png";